<template>
    <label for="compact-position">
        <input id="compact-position" @change="emitInput" type="checkbox" name="extend2" v-model="value" class="mr-1" />
        Compact Text
    </label>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    defaultValue: Boolean
});
const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function emitInput() {
    emit('update:modelValue', value.value);
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
    emit('update:modelValue', value.value);
});
</script>
